<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-body p-15 p-sm-20 p-md-25">
      <h5>{{ NoteReturn.note_ref }}</h5>
      <br />
      <h5>
        Date de création :
        <b v-if="NoteReturn.created_at">
          {{ getDate(NoteReturn.created_at) }}
        </b>
        |
        <b v-if="NoteReturn.client">
          {{ NoteReturn.client.store }}
        </b>
        (<b>{{ NoteReturn.for_name }}</b
        >)
        <span v-if="NoteReturn.city_return">
          ({{ NoteReturn.city_return }})
        </span>
      </h5>
    </div>
  </div>

  <div
    class="card mb-25 border-0 rounded-0 bg-white letter-spacing"
    v-if="NoteReturn.statut == 0"
  >
    <div class="card-header pb-2">
      <h5>Scan code suivi</h5>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <form @submit.prevent="SearchColis">
        <div class="row align-items-end">
          <div class="col-md-9">
            <div class="form-group">
              <label>Code Suivi :</label>
              <input
                type="text"
                class="form-control"
                placeholder="Code Suivi"
                v-model="codeColis"
              />
            </div>
          </div>
          <div class="col-md-3">
            <button type="submit" class="btn btn-success mb-2">
              <i class="ph ph-scan"></i>
            </button>
          </div>
          <div class="col-12">
            <hr />
          </div>
        </div>
      </form>
    </div>
  </div>

  <div
    class="card mb-25 border-0 rounded-0 bg-white letter-spacing"
    v-if="NoteReturn.statut == 0"
  >
    <div class="card-header pb-2">
      <h5>List des nouveaux colis</h5>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="row mb-3">
        <div class="col-md-9">
          <!-- Replace with your date picker if needed -->
          <input
            type="text"
            class="form-control"
            v-model="date_filter"
            placeholder="Date Range"
          />
        </div>
        <div class="col-md-3 text-end">
          <button class="btn btn-warning me-2" @click="FilterColis">
            <i class="flaticon-search"></i>
          </button>
          <button class="btn btn-danger" @click="Removefilter()">
            <i class="flaticon-close"></i> 
          </button>
        </div>
        <div class="col-12">
          <hr />
        </div>
        <div
          v-if="auth.can('ADD_BR_C')"
          class="col-md-6 d-flex align-items-center mb-2"
        >
          <button
            v-if="NoteReturn.statut == 0"
            class="btn btn-success me-2"
            @click="AddNewColis"
          >
            Ajouter
          </button>
          <label class="me-2 mb-0 text-nowrap">Voir</label>
          <v-select
            v-model="users1.per_page"
            :options="[10, 25, 50, 100]"
            :clearable="false"
            class="per-page-selector d-inline-block me-3"
            style="width: 90px"
            @update:modelValue="getRows1()"
          />
          <label class="mb-0">{{ users1.total }} entités</label>
        </div>
        <div
          class="col-md-6 d-flex justify-content-end align-items-center mb-2"
        >
          <input
            type="text"
            class="form-control"
            placeholder="Chercher"
            v-model="users1.searchTerm"
            @input="getRows1()"
          />
        </div>
      </div>
      <vue-good-table
        :columns="columns"
        :rows="rows1"
        :select-options="{
          selectOnCheckboxOnly: true,
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Colis Sélectionés',
          disableSelectInfo: true,
          selectAllByGroup: true,
        }"
        @select-all="onSelectAll"
        @selected-rows-change="selectionChanged"
      >
        <!-- <template #emptystate></template> -->
        <template #emptystate>
          <center>Aucune entrées correspondants trouvés</center>
        </template>
        <template #table-row="props">
          <template v-if="props.column.field === 'code'">
            <h6 class="text-warning" v-if="props.row.replace == 1">
              {{ props.row.code }}
              <i class="icon-repeat"></i>
            </h6>
            <h6 class="text-info" v-else-if="props.row.partial == 1">
              {{ props.row.code }}
              <i class="icon-corner-down-left"></i>
            </h6>
            <h6 v-else>
              {{ props.row.code }}
            </h6>
          </template>
          <template v-else-if="props.column.field === 'status'">
            <template v-if="props.row.delivered_by != 0">
              <div
                class="rounded-pill fs-13 badge text-bg-black custom-badge"
                :style="{
                  '--dynamic-bg':
                    globalStore.globalHelper('DELIVERED').code_color,
                }"
              >
                {{ globalStore.globalHelper("DELIVERED").name }}
              </div>
            </template>

            <template
              v-else-if="
                props.row.delivered_by == 0 &&
                (props.row.status_second || props.row.status_second != null)
              "
            >
              <div
                class="rounded-pill fs-13 badge text-bg-black custom-badge"
                :style="{
                  '--dynamic-bg': globalStore.globalHelper(
                    props.row.status_second
                  ).code_color,
                }"
              >
                {{ globalStore.globalHelper(props.row.status_second).name }}
              </div>
            </template>
            <template
              v-else-if="
                props.row.delivered_by == 0 &&
                (!props.row.status_second || props.row.status_second == null)
              "
            >
              <div
                class="rounded-pill fs-13 badge text-bg-black custom-badge"
                :style="{ '--dynamic-bg': props.row.code_color }"
              >
                {{ props.row.s_name }}
              </div>
            </template>
          </template>
          <template v-else-if="props.column.field === 'price'">
            <b>{{ props.row.price }}</b> {{ $devis }}
          </template>
          <template v-else-if="props.column.field === 'received_time'">
            <span class="text-nowrap" v-if="props.row.received_time">
              {{ getDate(props.row.received_time) }}
            </span>
            <span class="text-nowrap" v-else> </span>
          </template>
          <template v-else-if="props.column.field === 'liv_fees'">
            <template v-if="props.row.status == 'DELIVERED'"
              ><b>{{ props.row.liv_fees_livred }}</b> {{ $devis }}</template
            >
            <template v-if="props.row.status == 'REFUSE'"
              ><b>{{ props.row.liv_fees_refused }} </b> {{ $devis }}</template
            >
          </template>

          <template v-else-if="props.column.field === 'total'">
            <template v-if="props.row.status == 'DELIVERED'"
              ><b>{{ props.row.price - props.row.liv_fees_livred }} </b>
              {{ $devis }}</template
            >
            <template v-if="props.row.status == 'REFUSE'"
              ><b>{{ 0 - props.row.liv_fees_refused }} </b> {{ $devis }}</template
            >
          </template>

          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <div class="row mt-3">
        <div class="col-md-6"></div>
        <div class="col-md-6">
          <PaginatorContent
            :pagination="users1"
            :offset="9"
            @paginate="getRows1"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-header pb-2">
      <h5>List des colis ajoutés</h5>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="row mb-3">
        <div
          v-if="auth.can('ADD_BR_C')"
          class="col-md-6 d-flex align-items-center mb-2"
        >
          <button
            v-if="NoteReturn.statut == 0"
            class="btn btn-danger me-2"
            @click="RemoveNewColis"
          >
            Supprimer
          </button>
          <label class="me-2 mb-0 text-nowrap">Voir</label>
          <v-select
            v-model="users2.per_page"
            :options="[10, 25, 50, 100]"
            :clearable="false"
            class="per-page-selector d-inline-block me-3"
            style="width: 90px"
            @update:modelValue="getRows2()"
          />
          <label class="mb-0">{{ users2.total }} entités</label>
        </div>
        <div
          class="col-md-6 d-flex justify-content-end align-items-center mb-2"
        >
          <input
            type="text"
            class="form-control"
            placeholder="Chercher"
            v-model="users2.searchTerm"
            @input="getRows2()"
          />
        </div>
      </div>

      <vue-good-table
        :columns="columns"
        :rows="rows2"
        :select-options="{
          selectOnCheckboxOnly: true,
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Colis Sélectionés',
          disableSelectInfo: true,
          selectAllByGroup: true,
        }"
        @select-all="onSelectAllColis"
        @selected-rows-change="selectionChangedColis"
        responsive
      >
        <!-- <template #emptystate></template> -->
        <template #emptystate>
          <center>Aucune entrées correspondants trouvés</center>
        </template>
        <template #table-row="props">
          <template v-if="props.column.field === 'code'">
            <h6 class="text-warning" v-if="props.row.replace == 1">
              {{ props.row.code }}
              <i class="icon-repeat"></i>
            </h6>
            <h6 class="text-info" v-else-if="props.row.partial == 1">
              {{ props.row.code }}
              <i class="icon-corner-down-left"></i>
            </h6>
            <h6 v-else>
              {{ props.row.code }}
            </h6>
          </template>
          <template v-else-if="props.column.field === 'status'">
            <template v-if="props.row.delivered_by != 0">
              <div
                class="rounded-pill fs-13 badge text-bg-black custom-badge"
                :style="{
                  '--dynamic-bg':
                    globalStore.globalHelper('DELIVERED').code_color,
                }"
              >
                {{ globalStore.globalHelper("DELIVERED").name }}
              </div>
            </template>

            <template
              v-else-if="
                props.row.delivered_by == 0 &&
                (props.row.status_second || props.row.status_second != null)
              "
            >
              <div
                class="rounded-pill fs-13 badge text-bg-black custom-badge"
                :style="{
                  '--dynamic-bg': globalStore.globalHelper(
                    props.row.status_second
                  ).code_color,
                }"
              >
                {{ globalStore.globalHelper(props.row.status_second).name }}
              </div>
            </template>
            <template
              v-else-if="
                props.row.delivered_by == 0 &&
                (!props.row.status_second || props.row.status_second == null)
              "
            >
              <div
                class="rounded-pill fs-13 badge text-bg-black custom-badge"
                :style="{ '--dynamic-bg': props.row.code_color }"
              >
                {{ props.row.s_name }}
              </div>
            </template>
            <template v-else-if="props.column.field === 'price'">
              <b>{{ props.row.price }}</b> {{ $devis }}
            </template>
            <template v-else-if="props.column.field === 'received_time'">
              <span class="text-nowrap" v-if="props.row.received_time">
                {{ getDate(props.row.received_time) }}
              </span>
              <span class="text-nowrap" v-else> </span>
            </template>

            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <div class="row mt-3">
        <div class="col-md-6"></div>
        <div class="col-md-6">
          <PaginatorContent
            :pagination="users2"
            :offset="9"
            @paginate="getRows2"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import { useAuthStore } from "@/stores/auth";
import { useGlobalStore } from "@/stores/global";
import api from "@/utils/axios";
import moment from "moment/moment";
import { reactive } from "vue";
import { ref } from "vue";
import { defineComponent, onMounted, watch } from "vue";
import { useRoute } from "vue-router";

export default defineComponent({
  props: {
    rowNote: {
      type: Object,
      required: true,
    },
    getRecords: {
      type: Function,
      required: true,
    },
    isOpen: {
      type: Boolean,
      required: true,
    },
  },

  setup(props) {
    const { showToast } = useAppToast();

    const auth = useAuthStore();
    const user = auth.user;

    const globalStore = useGlobalStore();
    const route = useRoute();

    const AgenciesList = ref([]);
    const ClientsList = ref([]);
    const AgencyStockList = ref([]);
    const isLoader = ref(true);
    const searchTerm1 = ref("");
    const searchTerm2 = ref("");
    const pageLength = ref(10);
    const pageLength2 = ref(10);
    const columns = [
      {
        label: "Code Suivi",
        field: "code",
      },
      {
        label: "Client",
        field: "customer_name",
      },
      {
        label: "Date de réception",
        field: "received_time",
      },
      {
        label: "Ville",
        field: "city_name",
      },
      {
        label: "Status",
        field: "status",
      },
      {
        label: "Prix",
        field: "price",
      },
    ];

    const SelectedRows = ref([]);
    const SelectedNewRows = ref([]);
    const codeColis = ref("");
    const rows1 = ref([]);
    const rows2 = ref([]);
    const NoteReturn = ref(props.rowNote);
    const users = ref({
      searchSDate: "",
      searchEDate: "",
    });
    const date_filter = ref("");
    const users1 = reactive({
      searchTerm: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });
    const users2 = reactive({
      searchTerm: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });

    function getDate(value) {
      return moment.utc(String(value)).format("YYYY-MM-DD HH:mm");
    }
    async function SearchColis() {
      const data = new FormData();
      data.append("user_id", user.id);
      data.append("code_colis", codeColis.value);
      data.append("ref_note", NoteReturn.value.note_ref);
      data.append("note_type", "2");

      try {
        const res = await api.post(`/api/auth/Rn_C_ScanColis`, data);
        codeColis.value = "";
        if (res.data.message === "success") {
          const audio = new Audio("/sound.mp3");
          audio.play();
          showToast("Colis bien ajouté", "success");
          getData();
        } else if (res.data.message === "not exist") {
          const audio = new Audio("/erro.mp3");
          audio.play();
          showToast("Vous pouvez pas ajouter ce colis", "error");
        } else if (res.data.message === "error note") {
          const audio = new Audio("/erro.mp3");
          audio.play();
          showToast("Vous pouvez pas ajouter à ce bon", "error");
        } else if (res.data.message === "parcel exist") {
          const audio = new Audio("/erro.mp3");
          audio.play();
          showToast("Colis déjà existe dans ce bon !", "error");
        }
      } catch (error) {
        showToast("Erreur lors de l'ajout du colis", "error");
      }
    }
    const onSelectAll = (params: any) => {
      SelectedRows.value = params.selectedRows;
    };
    const selectionChanged = (params: any) => {
      SelectedRows.value = params.selectedRows;
    };
    const onSelectAllColis = (params: any) => {
      SelectedNewRows.value = params.selectedRows;
    };
    const selectionChangedColis = (params: any) => {
      SelectedNewRows.value = params.selectedRows;
    };

    async function getData() {
      console.log("Fetching data...");
      NoteReturn.value = props.rowNote;
      await Promise.all([getRows1(), getRows2()]);
    }
    async function getRows1(page = 1) {
      if (NoteReturn.value && NoteReturn.value.statut == 0) {
        isLoader.value = true;
        users1.current_page = page;
        try {
          const res = await api.get(
            `/api/auth/list_coli_cstrn?searchTerm=${users1.searchTerm}&page=${users1.current_page}&per_page=${users1.per_page}`,
            {
              params: {
                ref: NoteReturn.value.note_ref,
                searchSDate: users.value.searchSDate,
                searchEDate: users.value.searchEDate,
              },
            }
          );
          rows1.value = res.data.users.data;
          Object.assign(users1, res.data.users);
        } finally {
          isLoader.value = false;
        }
      }
    }
    async function getRows2(page = 1) {
      isLoader.value = true;
      users2.current_page = page;
      try {
        const res = await api.get(
          `/api/auth/list_coli_in_cstrn?searchTerm=${users2.searchTerm}&page=${users2.current_page}&per_page=${users2.per_page}&type=2`,
          {
            params: { ref: NoteReturn.value.note_ref },
          }
        );
        rows2.value = res.data.users.data;
        Object.assign(users2, res.data.users);
      } finally {
        isLoader.value = false;
      }
    }

    async function AddNewColis() {
      if (SelectedRows.value.length === 0) {
        showToast("Vous pouvez pas ajouter à ce bon", "error");
        return;
      }
      const data = new FormData();
      data.append("UserID", user.id);
      data.append("colis", JSON.stringify(SelectedRows.value));
      data.append("note_ref", NoteReturn.value.note_ref);
      data.append("note_type", "2");

      try {
        const res = await api.post("/api/auth/Add_colis_to_rnc", data);
        if (res.data.message === "success") {
          showToast("Ajouté avec succès", "success");
          getData();
        } else {
          showToast("Something went wrong! Please try again", "error");
        }
      } catch (error) {
        showToast("Erreur lors de l'ajout des colis", "error");
      }
    }

    async function RemoveNewColis() {
      if (SelectedNewRows.value.length === 0) {
        showToast("Vous pouvez pas supprimer à ce bon", "error");
        return;
      }
      const data = new FormData();
      data.append("UserID", user.id);
      data.append("colis", JSON.stringify(SelectedNewRows.value));
      data.append("note_ref", NoteReturn.value.note_ref);

      try {
        const res = await api.post("/api/auth/remove_colis_rnc", data);
        if (res.data.message === "success") {
          showToast("Supprimé avec succès", "success");
          getData();
        } else {
          showToast("Something went wrong! Please try again", "error");
        }
      } catch (error) {
        showToast("Erreur lors de la suppression des colis", "error");
      }
    }

    function convert(str) {
      const date = new Date(str);
      const mnth = ("0" + (date.getMonth() + 1)).slice(-2);
      const day = ("0" + date.getDate()).slice(-2);
      return [date.getFullYear(), mnth, day].join("-");
    }

    function FilterColis() {
      // If you use a date picker, replace this logic accordingly
      users.value.searchSDate = date_filter.value
        ? convert(date_filter.value.split(" - ")[0])
        : "";
      users.value.searchEDate = date_filter.value
        ? convert(date_filter.value.split(" - ")[1])
        : "";
      getRows1();
    }

    function Removefilter() {
      users.value.searchSDate = "";
      users.value.searchEDate = "";
      date_filter.value = "";
      getRows1();
    }

    onMounted(() => {
      console.log("opeen ", props.isOpen);
      if (props.isOpen) {
        getData();
        console.log("Modal is open, data fetched.");
      }
    });

    watch(
      () => props.isOpen,
      (newVal) => {
        console.log("isOpen changed:", newVal);
        if (newVal) {
          getData();
          console.log("Modal is open, data fetched.");
        }
      },
      { immediate: true }
    );

    return {
      auth,
      globalStore,
      getDate,
      columns,
      rows1,
      rows2,
      users1,
      users2,
      codeColis,
      SearchColis,
      onSelectAll,
      selectionChanged,
      onSelectAllColis,
      selectionChangedColis,
      getRows1,
      getRows2,
      AddNewColis,
      RemoveNewColis,
      date_filter,
      users,
      FilterColis,
      Removefilter,
      NoteReturn,
    };
  },
});
</script>

